import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconSize, NavigationItem } from '@stylehaven/components';

@Component({
    standalone: false,
    selector: 'digihaven-dashboard-fast-links',
    templateUrl: './dashboard-fast-links.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardFastLinksComponent {
    readonly IconSize: typeof IconSize = IconSize;

    @Input() title!: string;
    @Input() subtitle!: string;
    @Input() navigationItems!: NavigationItem[];
}
